import { PayloadAction, createSlice } from '@reduxjs/toolkit';

export type RequestHistoryFilters = {
    contractFilter: string;
    dateFilter: string;
    statusFilter: string;
    cleared: boolean;
};

const initialState: RequestHistoryFilters = {
    contractFilter: 'all',
    dateFilter: 'all',
    statusFilter: 'all',
    cleared: false,
};

const requestHistoryFiltersSlice = createSlice({
    name: 'requestHistoryFiltersSlice',
    initialState: initialState,
    reducers: {
        setContractFilter(state, action: PayloadAction<string>) {
            state.contractFilter = action.payload;
            state.cleared = false;
        },
        setDateFilter(state, action: PayloadAction<string>) {
            state.dateFilter = action.payload;
            state.cleared = false;
        },
        setStatusFilter(state, action: PayloadAction<string>) {
            state.statusFilter = action.payload;
            state.cleared = false;
        },
        clearFilters(state) {
            state.contractFilter = 'all';
            state.dateFilter = 'all';
            state.statusFilter = 'all';
            state.cleared = true;
        },
    },
});

export const requestHistoryFiltersReducer = requestHistoryFiltersSlice.reducer;
export const requestHistoryFiltersActions = requestHistoryFiltersSlice.actions;
